/* eslint-disable */
import * as Types from './types';

import { ShareYourLooksFragmentDoc } from './ShareYourLooks';
import { ImageFragmentDoc } from './Image';
import { CollectionListingSectionFragmentDoc } from './CollectionListingSection';
import { ManualProductRecommendationsFragmentDoc } from './ManualProductRecommendations';
import { GetLookFragmentDoc } from './GetLook';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type CollectionSectionsQueryVariables = Types.Exact<{
  handle: Types.Scalars['String'];
  locale?: Types.InputMaybe<Types.Scalars['String']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type CollectionSectionsQuery = { __typename?: 'Query', collection?: { __typename?: 'CollectionCollection', items: Array<{ __typename?: 'Collection', sections?: { __typename?: 'CollectionBaseSectionsCollection', items: Array<{ __typename: 'CollectionListingSection', title?: string | null, proContent?: boolean | null, collectionsCollection?: { __typename?: 'CollectionListingSectionCollectionsCollection', items: Array<{ __typename?: 'Collection', title?: string | null, handle?: string | null, shortDescription?: string | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null } | { __typename: 'GetLook', title?: string | null, subtitle?: string | null, descriptionDesktop?: string | null, descriptionMobile?: string | null, ctaTitle?: string | null, ctaLink?: string | null, textContentSide?: string | null, leftImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, rightImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | { __typename: 'ManualProductRecommendations', title?: string | null, description?: string | null, descriptionLinkUrl?: string | null, descriptionLinkText?: string | null, descriptionLinkOpenLinkInNewTab?: boolean | null, ctaText?: string | null, ctaUrl?: string | null, openLinkInNewTab?: boolean | null, enableBackground?: boolean | null, filters?: string | null, proContent?: boolean | null, ruleContext?: string | null, recommendationsType?: string | null, collection?: { __typename?: 'Collection', title?: string | null, handle?: string | null, id?: string | null } | null } | { __typename: 'ShareYourLooks', title?: string | null, description?: string | null, ctaUrl?: string | null, ctaTitle?: string | null, openLinkInNewTab?: boolean | null, proContent?: boolean | null, desktopImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, mobileImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null } | null> } | null };

export declare const collectionSections: import("graphql").DocumentNode;

export const CollectionSectionsDocument = /*#__PURE__*/ `
    query collectionSections($handle: String!, $locale: String = "en-US", $preview: Boolean = false) {
  collection: collectionCollection(
    limit: 1
    locale: $locale
    where: {handle: $handle, sys: {id_exists: true}}
    preview: $preview
  ) {
    items {
      sections: baseSectionsCollection(where: {sys: {id_exists: true}}) {
        items {
          __typename
          ... on ShareYourLooks {
            ...ShareYourLooksFragment
          }
          ... on CollectionListingSection {
            ...CollectionListingSectionFragment
          }
          ... on ManualProductRecommendations {
            ...ManualProductRecommendationsFragment
          }
          ... on GetLook {
            ...GetLookFragment
          }
        }
      }
    }
  }
}
    ${ShareYourLooksFragmentDoc}
${ImageFragmentDoc}
${CollectionListingSectionFragmentDoc}
${ManualProductRecommendationsFragmentDoc}
${GetLookFragmentDoc}`;
export const useCollectionSectionsQuery = <
      TData = CollectionSectionsQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: CollectionSectionsQueryVariables,
      options?: UseQueryOptions<CollectionSectionsQuery, TError, TData>
    ) =>
    useQuery<CollectionSectionsQuery, TError, TData>(
      ['collectionSections', variables],
      fetcher<CollectionSectionsQuery, CollectionSectionsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CollectionSectionsDocument, variables, options),
      options
    );

useCollectionSectionsQuery.getKey = (variables: CollectionSectionsQueryVariables) => ['collectionSections', variables];
;

useCollectionSectionsQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: CollectionSectionsQueryVariables, options?: RequestInit['headers']) => fetcher<CollectionSectionsQuery, CollectionSectionsQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CollectionSectionsDocument, variables, options);